// src/components/Header.js - Version avec bouton profil
import React from 'react';
import { RefreshCw, LogOut, User } from 'lucide-react';

const Header = ({ currentUser, onRefresh, onLogout, onProfileClick }) => {
  return (
    <div className="header">
      <div className="header-content">
        <div>
          <h1>Backoffice - Gestion des Boutiques SAV</h1>
          <p className="subtitle">Validez et gérez les boutiques scrapées</p>
        </div>
        <div className="header-actions">
          <div 
            className="user-info"
            onClick={onProfileClick}
            style={{ cursor: 'pointer', transition: 'all 0.2s' }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#f3f4f6';
              e.currentTarget.style.transform = 'scale(1.02)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#f9fafb';
              e.currentTarget.style.transform = 'scale(1)';
            }}
            title="Cliquer pour voir mon profil"
          >
            <User className="icon" />
            <div>
              <div className="user-name">{currentUser.name}</div>
              <div className="user-role">{currentUser.role}</div>
            </div>
          </div>
          <button onClick={onRefresh} className="btn-refresh">
            <RefreshCw className="icon" />
            Actualiser
          </button>
          <button onClick={onLogout} className="btn-logout">
            <LogOut className="icon" />
            Déconnexion
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;